"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkToolbarButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _cn = require("@udecode/cn");
var _ri = require("react-icons/ri");
var _toolbar = require("./toolbar");
var _useLinkToolbarButton = require("../hooks/useLinkToolbarButton");
var _jsxRuntime = require("react/jsx-runtime");
var LinkToolbarButton = exports.LinkToolbarButton = (0, _cn.withRef)(function (rest, ref) {
  var state = (0, _useLinkToolbarButton.useLinkToolbarButtonState)();
  var _ref = (0, _useLinkToolbarButton.useLinkToolbarButton)(state),
    props = _ref.props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_toolbar.ToolbarButton, _objectSpread({
    ref: ref,
    tooltip: "Link"
  }, props, rest, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ri.RiLink, {})
  }));
});